import styled from "styled-components";
import { ACTIVE } from "../../css-classes";

export const ArenaHeaderButtonDefaultBox = styled.div`
    display: flex;
    flex:1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow:hidden;

    &.${ACTIVE}{
        border-bottom: 4px solid ${props => props.theme.components.miniOrbit.colors.arenaMenuActiveIndicator};
    }
 `;